module.exports = __webpack_public_path__ + "img/Lynette Vu.e145643c.jpg";